import {
  HashLocationStrategy,
  LocationStrategy,
  registerLocaleData,
} from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import localePt from '@angular/common/locales/pt';
import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  MsalBroadcastService,
  MsalGuard,
  MsalInterceptor,
  MsalModule,
  MsalService,
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
} from '@azure/msal-angular';
import { NgSelectModule } from '@ng-select/ng-select';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { ChartsModule, ThemeService } from 'ng2-charts';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import {
  MSALGuardConfigFactory,
  MSALInstanceFactory,
  MSALInterceptorConfigFactory,
} from 'src/environments/azure.config';
import { AppComponent } from './app.component';
import { routing } from './app.routing';
import { APP_VERSION } from './core/constants/const';
import { GlobalErrorHandler } from './globalErrorHandler';
import { CalendarEditConfirmComponent } from './shared/components/calendar/calendar-edit/calendar-edit-confirm/calendar-edit-confirm.component';
import { CalendarEditListUsersComponent } from './shared/components/calendar/calendar-edit/calendar-edit-list-users/calendar-edit-list-users.component';
import { CalendarEditNotConfirmComponent } from './shared/components/calendar/calendar-edit/calendar-edit-not-confirm/calendar-edit-not-confirm.component';
import { CalendarViewAssistanceOnlyParkingComponent } from './shared/components/calendar/calendar-view-assistance-only-parking/calendar-view-assistance-only-parking.component';
import { CalendarViewAssistanceUserComponent } from './shared/components/calendar/calendar-view-assistance-user/calendar-view-assistance-user.component';
import { CalendarViewAssistanceComponent } from './shared/components/calendar/calendar-view-assistance/calendar-view-assistance.component';
import { CalendarComponent } from './shared/components/calendar/calendar.component';
import { ConfirmComponent } from './shared/components/confirm_dialog/confirm.component';
import { MyDatePickerModule } from './shared/components/date_picker/datepicker.module';
import { FlashMessagesModule } from './shared/components/flash_messages/flash.module';
import { LopdPuigComponent } from './shared/components/lopd/lopd-puig/lopd-puig.component';
import { MenuExternalComponent } from './shared/components/menu-external/menu-external.component';
import { MenuComponent } from './shared/components/menu/menu.component';
import { ModalAcceptDialogComponent } from './shared/components/modal-accept-dialog/modal-accept-dialog.component';
import { ModalErrorMobileComponent } from './shared/components/modal-error-mobile/modal-error-mobile.component';
import { ModalIndicateDepartmentComponent } from './shared/components/modal-indicate-department/modal-indicate-department.component';
import { ModalReservationGenericComponent } from './shared/components/modal-reservation-generic/modal-reservation-generic.component';
import { ModalReservationComponent } from './shared/components/modal-reservation/modal-reservation.component';
import { OauthComponent } from './shared/components/oauth.component';
import { SoonPageComponent } from './shared/components/soon-page/soon-page.component';
import { SpinnerSmalComponent } from './shared/components/spinner-smal/spinner-smal.component';
import { SpinnerComponent } from './shared/components/spinner/spinner.component';
import { AddTableDirective } from './shared/directives/add-table.directive';
import { ClickOutsideModule } from './shared/directives/click-outside/click-outside.module';
import { CustomDatePipe } from './shared/pipes/custom.date.pipe';
import { CustomTimePipe } from './shared/pipes/custom.time.pipe';
import { DateStringPipe } from './shared/pipes/date.string.pipe';
import { ImageExistPipe } from './shared/pipes/imagenExist.pipe';
import { MessagesPipe } from './shared/pipes/messages.pipe';
import { AdinService } from './shared/services/adin.service';
import { AuthenticationService } from './shared/services/authentication.service';
import { BaseService } from './shared/services/base.service';
import { BuildLogService } from './shared/services/build.log.service';
import { BuildingService } from './shared/services/building.service';
import { ConfirmService } from './shared/services/confirm.service';
import { CustomExternalModuleService } from './shared/services/custom-external-module.service';
import { DalkonService } from './shared/services/dalkon.service';
import { DepartmentService } from './shared/services/department.service';
import { EquipementService } from './shared/services/equipement.service';
import { FlashMessagesService } from './shared/services/flash-messages.service';
import { HeadquartersService } from './shared/services/headquarters.service';
import { LoginService } from './shared/services/login.service';
import { NavigatorRefreshService } from './shared/services/navigator.refresh.service';
import { ParkingService } from './shared/services/parking.service';
import { ReservationService } from './shared/services/reservation.service';
import { RoomService } from './shared/services/room.service';
import { UserService } from './shared/services/user.service';
import { WaitingService } from './shared/services/waiting.service';
import { Utils } from './shared/utils/utils';
import { AppVersionComponent } from './views/app-version/app-version.component';
import { AssistanceIberdrolaUserComponent } from './views/assistance-iberdrola-user/assistance-iberdrola-user.component';
import { AssistanceIberdrolaComponent } from './views/assistance-iberdrola/assistance-iberdrola.component';
import { ModalEditAssistanceComponent } from './views/assistance-iberdrola/modal-edit-assistance/modal-edit-assistance.component';
import { AssistanceUserComponent } from './views/assistance-user/assistance-user.component';
import { AssistanceComponent } from './views/assistance/assistance.component';
import { BoxOfficeComponent } from './views/box-office/box-office.component';
import { ReservationDeskComponent } from './views/box-office/reservation-desk/reservation-desk.component';
import { CantineComponent } from './views/cantine/cantine.component';
import { CarWashListComponent } from './views/car-wash/car-wash-list/car-wash-list.component';
import { CarWashReserveMobileComponent } from './views/car-wash/car-wash-reserve-mobile/car-wash-reserve-mobile.component';
import { CarWashReserveComponent } from './views/car-wash/car-wash-reserve/car-wash-reserve.component';
import { CarWashComponent } from './views/car-wash/car-wash.component';
import { CustomExternalModuleComponent } from './views/custom-external-module/custom-external-module.component';
import { DescargasComponent } from './views/descargas/descargas.component';
import { DinningOccupationComponent } from './views/dinning-occupation/dinning-occupation.component';
import { DinningPositionComponent } from './views/dinning-position/dinning-position.component';
import { DorletComponent } from './views/dorlet/dorlet.component';
import { UrlHelperService } from './views/dorlet/dorlet.service';
import { ExternalModuleComponent } from './views/external-module/external-module.component';
import { HomeParkingComponent } from './views/home/home-parking.component';
import { HomeComponent } from './views/home/home.component';
import { IncidenceNewFormComponent } from './views/incidence/incidence-new-form/incidence-new-form.component';
import { IncidenceComponent } from './views/incidence/incidence.component';
import { AvailablePositionsComponent } from './views/job-position/available-positions/available-positions.component';
import { JobPositionComponent } from './views/job-position/job-position.component';
import { ListOfPositionsComponent } from './views/job-position/list-of-positions/list-of-positions.component';
import { MultipleReservationComponent } from './views/job-position/multiple-reservation/multiple-reservation.component';
import { ReservationByPositionComponent } from './views/job-position/reservation-by-position/reservation-by-position.component';
import { SearchPeopleComponent } from './views/job-position/search-people/search-people.component';
import { SearchUserPositionComponent } from './views/job-position/search-user-position/search-user-position.component';
import { ShareMyPositionComponent } from './views/job-position/share-my-position/share-my-position.component';
import { UserPositionsComponent } from './views/job-position/user-positions/user-positions.component';
import { LoginAzureComponent } from './views/login-azure/login-azure.component';
import { LoginSwitcherComponent } from './views/login-switcher/login-switcher.component';
import { LoginComponent } from './views/login/login.component';
import { LopdComponent } from './views/lopd/lopd.component';
import { ParkingOccupationMenuComponent } from './views/parking-occupation-menu/parking-occupation-menu.component';
import { ParkingOccupationComponent } from './views/parking-occupation/parking-occupation.component';
import { ParkingOneComponent } from './views/parking-one/parking-one.component';
import { ParkingComponent } from './views/parking/parking.component';
import { ModalLanguageComponent } from './views/profile/modal-language/modal-language.component';
import { ProfileFormComponent } from './views/profile/profile-form/profile-form.component';
import { ProfileComponent } from './views/profile/profile.component';
import { QuestionAndAnswersListComponent } from './views/questions-and-answers/question-and-answers-list/question-and-answers-list.component';
import { QuestionAndAnswersNewComponent } from './views/questions-and-answers/question-and-answers-new/question-and-answers-new.component';
import { QuestionAndAnswersTypeComponent } from './views/questions-and-answers/question-and-answers-type/question-and-answers-type.component';
import { QuestionsAndAnswersComponent } from './views/questions-and-answers/questions-and-answers.component';
import { ReservationListComponent } from './views/reservation/reservation.list.component';
import { ReservationCardComponent } from './views/reservation/reservation_card/reservation.card.component';
import { ReservationDetailComponent } from './views/reservation/reservation_detail/reservation.detail.component';
import { ReservationDialog } from './views/reservation/reservation_dialog/reservation.dialog';
import { ReservationInvitesComponent } from './views/reservation/reservation_invites/reservation.invites.component';
import { ReservationNewDetailByHQ } from './views/reservation/reservation_new_by_headquarters/reservation.new.detail.by.hq';
import { ReservationNewDetailByRoom } from './views/reservation/reservation_new_by_room/reservation.new.detail.room';
import { ReservationNewFormComponent } from './views/reservation/reservation_new_form/reservation.new.form';
import { ReservationResultsByRoomAndPeriodComponent } from './views/reservation/reservation_search_by_room_and_period/reservation.results.by.room.period.component';
import { ReservationSearchByRoomAndPeriodComponent } from './views/reservation/reservation_search_by_room_and_period/reservation.search.by.room.period.component';
import { ReservationSpeedDetailComponent } from './views/reservation/reservation_speed/reservation.speed.detail.component';
import { ReservationSpeedNewDetail } from './views/reservation/reservation_speed/reservation.speed.new.detail';
import { ResetPasswordComponent } from './views/reset-password/reset-password.component';
import { ListComponent } from './views/resource/list/list.component';
import { ReserveMobileComponent } from './views/resource/reserve-mobile/reserve-mobile.component';
import { ReserveComponent } from './views/resource/reserve/reserve.component';
import { ResourceComponent } from './views/resource/resource.component';
import { RoomAvailableComponent } from './views/room/room.available.component';
import { RoomCardComponent } from './views/room/room.card.component';
import { RoomDetailComponent } from './views/room/room.detail.component';
import { RoomSpeedAvailableComponent } from './views/room/room_speed/room.speed.available.component';
import { RoomSpeedDetailComponent } from './views/room/room_speed/room.speed.detail.component';
import { RoomDetailHeaderComponent } from './views/room/room_without_time/room.detail.header.component';
import { RoomWithoutTime } from './views/room/room_without_time/room.without.time';
import { RoomWithoutTimeDetail } from './views/room/room_without_time/room.without.time.detail';
import { RoomWithoutTimeMosaic } from './views/room/room_without_time/room.without.time.mosaic';
import { AssignPlaceComponent } from './views/security-search/assign-place/assign-place.component';
import { SecuritySearchComponent } from './views/security-search/security-search.component';
import { ShuttleComponent } from './views/shuttle/shuttle.component';
import { SideModalComponent } from './views/side-modal/side-modal.component';
import { StewardComponent } from './views/steward/steward.component';
import { StewardUrlHelperService } from './views/steward/steward.service';
import { ValidateTokenComponent } from './views/validate-token/validate-token.component';
import { WaitingDetailComponent } from './views/wating/wating.detail.component';
import { QuestionAndAnswersResultComponent } from './views/questions-and-answers/question-and-answers-result/question-and-answers-result.component';
import { CheckInWithCodeComponent } from './views/job-position/check-in-with-code/check-in-with-code.component';
import { CookiesNoticeComponent } from './views/cookies-notice/cookies-notice.component';
import { CookiesNoticeBnpesComponent } from './shared/components/cookies-notice/cookies-notice-bnpes/cookies-notice-bnpes.component'

// Languages
registerLocaleData(localeEs, 'es');
registerLocaleData(localePt, 'pt');
registerLocaleData(localeEn, 'en');

const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1;

@NgModule({
  declarations: [
    AppComponent,
    OauthComponent,
    ConfirmComponent,
    LoginComponent,
    MenuComponent,
    HomeComponent,
    ParkingComponent,
    IncidenceComponent,
    WaitingDetailComponent,
    ReservationListComponent,
    ReservationCardComponent,
    ReservationDetailComponent,
    ReservationNewFormComponent,
    ReservationNewDetailByHQ,
    ReservationNewDetailByRoom,
    ReservationSpeedNewDetail,
    ReservationSpeedDetailComponent,
    RoomAvailableComponent,
    RoomCardComponent,
    RoomDetailComponent,
    ProfileComponent,
    DescargasComponent,
    RoomWithoutTime,
    RoomWithoutTimeDetail,
    ReservationDialog,
    RoomWithoutTimeMosaic,
    RoomSpeedAvailableComponent,
    RoomSpeedDetailComponent,
    CustomDatePipe,
    CustomTimePipe,
    MessagesPipe,
    DateStringPipe,
    HomeParkingComponent,
    ReservationInvitesComponent,
    ValidateTokenComponent,
    ReservationSearchByRoomAndPeriodComponent,
    ReservationResultsByRoomAndPeriodComponent,
    RoomDetailHeaderComponent,
    IncidenceNewFormComponent,
    SoonPageComponent,
    ParkingOneComponent,
    BoxOfficeComponent,
    AddTableDirective,
    ModalReservationComponent,
    ReservationDeskComponent,
    SpinnerComponent,
    ProfileFormComponent,
    SecuritySearchComponent,
    ModalErrorMobileComponent,
    JobPositionComponent,
    ReservationByPositionComponent,
    ListOfPositionsComponent,
    LoginAzureComponent,
    LoginSwitcherComponent,
    ResetPasswordComponent,
    AppVersionComponent,
    ShareMyPositionComponent,
    SearchUserPositionComponent,
    MultipleReservationComponent,
    SearchPeopleComponent,
    AvailablePositionsComponent,
    UserPositionsComponent,
    ModalIndicateDepartmentComponent,
    DinningPositionComponent,
    AssistanceComponent,
    AssistanceUserComponent,
    DinningOccupationComponent,
    ParkingOccupationComponent,
    CantineComponent,
    CookiesNoticeComponent,
    CookiesNoticeBnpesComponent,
    CalendarComponent,
    CalendarEditConfirmComponent,
    CalendarEditNotConfirmComponent,
    CalendarEditListUsersComponent,
    CalendarViewAssistanceComponent,
    CalendarViewAssistanceUserComponent,
    CalendarViewAssistanceOnlyParkingComponent,
    ParkingOccupationMenuComponent,
    ShuttleComponent,
    AssignPlaceComponent,
    ModalLanguageComponent,
    LopdComponent,
    LopdPuigComponent,
    ModalAcceptDialogComponent,
    ResourceComponent,
    ListComponent,
    ReserveComponent,
    ModalReservationGenericComponent,
    ReserveMobileComponent,
    MenuExternalComponent,
    CustomExternalModuleComponent,
    ExternalModuleComponent,
    AssistanceIberdrolaComponent,
    ModalEditAssistanceComponent,
    AssistanceIberdrolaUserComponent,
    SpinnerSmalComponent,
    ImageExistPipe,
    SideModalComponent,
    CarWashComponent,
    CarWashListComponent,
    CarWashReserveComponent,
    CarWashReserveMobileComponent,
    DorletComponent,
    StewardComponent,
    QuestionsAndAnswersComponent,
    QuestionAndAnswersListComponent,
    QuestionAndAnswersNewComponent,
    QuestionAndAnswersTypeComponent,
    QuestionAndAnswersResultComponent,
    CheckInWithCodeComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    ReactiveFormsModule,
    routing,
    FlashMessagesModule,
    MyDatePickerModule,
    BrowserAnimationsModule,
    AutocompleteLibModule,
    InfiniteScrollModule,
    ClickOutsideModule,
    MsalModule,
    ChartsModule,
    NgSelectModule,
  ],
  providers: [
    BaseService,
    FlashMessagesService,
    ConfirmService,
    AuthenticationService,
    UserService,
    ReservationService,
    EquipementService,
    RoomService,
    WaitingService,
    UrlHelperService,
    StewardUrlHelperService,
    DalkonService,
    BuildingService,
    DepartmentService,
    LoginService,
    ParkingService,
    Utils,
    NavigatorRefreshService,
    HeadquartersService,
    AdinService,
    ThemeService,
    BuildLogService,
    CustomExternalModuleService,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    {
      provide: LOCALE_ID,
      useFactory: () => {
        const navigatorValue = navigator
          ? navigator.language.substr(0, 2)
          : 'es';

        const availableLanguages = ['es', 'en', 'pt'];

        return availableLanguages.includes(navigatorValue)
          ? navigatorValue
          : 'es';
      },
    },
    {
      // processes all errors
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory,
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    {
      provide: APP_VERSION,
      useValue: `${require('../../package.json').version}`,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
